export var NavController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initMobileMenu();
                //this.initMobileMenu({ offset: 120 });
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initMobileMenu: function (options) {
        if (options === void 0) { options = {}; }
        var _a = options.offset, offset = _a === void 0 ? 120 : _a, _b = options.breakpoint, breakpoint = _b === void 0 ? 768 : _b;
        var nav = document.querySelector('.nav');
        var menu = document.querySelector('.nav-menu');
        var hamburguer = document.querySelector('.hamburguer-icon');
        var body = document.body;
        var closeMenu = function () {
            nav === null || nav === void 0 ? void 0 : nav.classList.remove('active');
            menu === null || menu === void 0 ? void 0 : menu.classList.remove('active');
            hamburguer === null || hamburguer === void 0 ? void 0 : hamburguer.classList.remove('open');
            body.style.overflow = '';
        };
        var toggleMenu = function () {
            if (!nav || !menu || !hamburguer)
                return;
            hamburguer.classList.toggle('open');
            nav.classList.toggle('active');
            menu.classList.toggle('active');
            body.style.overflow = body.style.overflow === 'hidden' ? '' : 'hidden';
        };
        var scrollToAnchorWithOffset = function (target, customOffset) {
            var usedOffset = typeof customOffset === 'number' ? customOffset : offset;
            var computeTop = function () {
                var elementTop = target.getBoundingClientRect().top + window.scrollY;
                return Math.max(0, elementTop - usedOffset);
            };
            // First pass
            var firstTop = computeTop();
            window.scrollTo({ top: firstTop, behavior: 'smooth' });
            // Second pass (fixes incorrect positions caused by layout reflow)
            setTimeout(function () {
                var secondTop = computeTop();
                window.scrollTo({ top: secondTop, behavior: 'smooth' });
            }, 150);
        };
        // Hamburger click toggles the mobile menu
        hamburguer === null || hamburguer === void 0 ? void 0 : hamburguer.addEventListener('click', toggleMenu);
        // Menu links click: scroll to anchor and close the menu
        if (menu) {
            var links = menu.querySelectorAll('a[href^="#"]');
            links.forEach(function (link) {
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    var href = link.getAttribute('href');
                    if (!href || href === '#') {
                        closeMenu();
                        return;
                    }
                    var target = document.querySelector(href);
                    if (!target) {
                        closeMenu();
                        return;
                    }
                    // Optional per-link offset (e.g. data-offset="140")
                    var dataOffset = link.dataset.offset ? Number(link.dataset.offset) : undefined;
                    closeMenu();
                    // Wait one frame so layout updates after closing the menu (more accurate scroll position)
                    requestAnimationFrame(function () {
                        scrollToAnchorWithOffset(target, Number.isFinite(dataOffset) ? dataOffset : undefined);
                    });
                });
            });
        }
        // Reset menu when switching to desktop layout
        window.addEventListener('resize', function () {
            if (window.innerWidth > breakpoint) {
                closeMenu();
            }
        });
    },
};
